import { PO_BOX_PREFIX, SEQUENCETYPES_PREFIX } from "./Constants"

export const sequenceGenerator = (docType, counter, includeYear = false) => {
    const sequencePrefix = docType ? SEQUENCETYPES_PREFIX[docType] : "";
    const nextSequenceNumber = (counter.count || 0) + 1;
    const year = new Date().getFullYear();
    return `${sequencePrefix}${(`${nextSequenceNumber}`.padStart(5,"0"))}${includeYear ? `-${year}` : ""}`;
}

export const poBoxLabelGenerator = (userPoBox) => {
    return `${PO_BOX_PREFIX} ${userPoBox.boxNumber}`;
}

export const poBoxSheinLabelGenerator = (userPoBox) => {
    const mapping = 'abcdefghij';
    const numberPoBox = Array.from(userPoBox?.boxNumber || '').map(digit => mapping[parseInt(digit)]).join('').toUpperCase();
  
    return `${PO_BOX_PREFIX} ${numberPoBox}`;
}

